import React from 'react';
import './InfoMessage.scss';
import PropTypes from 'prop-types';

const infoMessage = require('b_').with('info-message');

export const InfoMessage = ({ message, children, icon }) => (
    <div className={infoMessage()}>
        {icon && <div className={infoMessage('icon', { [icon]: true })} />}
        <div className={infoMessage('message')}>{children ?? message}</div>
    </div>
);

InfoMessage.propTypes = {
    message: PropTypes.string,
    children: PropTypes.node,
    icon: PropTypes.string,
};

InfoMessage.defaultProps = {
    message: undefined,
    children: undefined,
    icon: undefined,
};
